<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="序列号" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select v-model="search.status" placeholder="状态" class="filter-item" style="width: 130px" clearable>
        <el-option v-for="item in option.status" :key="item.key" :label="item.val" :value="item.key"/>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button type="primary" class="filter-item" style="margin-left: 10px;" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="序列号" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.sn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template slot-scope="scope">
          <span>{{ scope.row.brand }}</span>
        </template>
      </el-table-column>
      <el-table-column label="型号" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.spec }}</span>
        </template>
      </el-table-column>
      <el-table-column label="位置" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.addr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="管线体积" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.pip }}ul</span>
        </template>
      </el-table-column>
      <el-table-column label="梯度延迟体积" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.grad }}ml</span>
        </template>
      </el-table-column>
      <el-table-column label="启用时间" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.start }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="120px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="序列号" prop="sn">
          <el-input v-model="temp.sn" placeholder="请填写序列号，添加后不可修改" v-if="!temp.id" />
          <span v-else>{{ temp.sn }}</span>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model="temp.brand" placeholder="请填写品牌"/>
        </el-form-item>
        <el-form-item label="型号" prop="spec">
          <el-input v-model="temp.spec" placeholder="请填写型号"/>
        </el-form-item>
        <el-form-item label="位置" prop="addr">
          <el-input v-model="temp.addr" placeholder="请填写位置"/>
        </el-form-item>
        <el-form-item label="管线体积" prop="pip">
          <el-input v-model="temp.pip" placeholder="请填写管线体积">
            <template slot="append">ul</template>
          </el-input>
        </el-form-item>
        <el-form-item label="梯度延迟体积" prop="grad">
          <el-input v-model="temp.grad" placeholder="请填写梯度延迟体积">
            <template slot="append">ml</template>
          </el-input>
        </el-form-item>
        <el-form-item label="启用时间" prop="start">
          <el-date-picker v-model="temp.start" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" v-for="(row, idx) in option.status" :key="idx" :label="row.key">{{ row.val }}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.edit = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
    <!-- edit -->

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{key: '1', val: '可用'}, {key: '0', val: '停用'}]
}

export default {
  name: 'AdminDev',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: ''
      },
      option: option,
      user: [],
      dia: {
        edit: false
      },
      temp: {},

      rules: {
        sn: [{ required: true, message: '请填写序列号', trigger: 'blur' }],
        brand: [{ required: true, message: '请填写品牌', trigger: 'blur' }],
        spec: [{ required: true, message: '请填写型号', trigger: 'blur' }],
        addr: [{ required: true, message: '请填写位置', trigger: 'blur' }],
        pip: [{ required: true, message: '请填写管线体积', trigger: 'blur' }],
        grad: [{ required: true, message: '请填写梯度延迟体积', trigger: 'blur' }],
        start: [{ required: true, message: '请选择项目开始时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/dev/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.temp = {}
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/dev/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dia {
  .tip {
    color: $dark;
    font-size: 12px;
  }
}
</style>

